import { Document } from 'react-pdf';
import { Loader2, AlertCircle, BookText } from 'lucide-react';

export default function PDFDocumentContent({
  contentPaddingClass,
  numPages,
  workerReady,
  effectivePdfUrl,
  pdfOptions,
  onDocumentLoadSuccess,
  onDocumentLoadError,
  sectionsLength,
  loading,
  children,
}) {
  return (
    <div className={contentPaddingClass}>
      {numPages && workerReady && (
        <Document
          file={effectivePdfUrl}
          options={pdfOptions}
          key={effectivePdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          loading={
            <div className="flex flex-col items-center justify-center h-64 space-y-4">
              <Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--primary))]" />
              <p className="text-sm text-muted-foreground">Loading PDF...</p>
              <div className="w-full max-w-2xl h-[800px] bg-gray-200 rounded-lg animate-pulse" />
            </div>
          }
          error={
            <div className="flex flex-col items-center justify-center h-64 p-8">
              <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
              <p className="text-red-600 mb-2">Failed to load PDF</p>
              <p className="text-sm text-muted-foreground text-center">
                Please try again or contact support if the problem persists.
              </p>
            </div>
          }
        >
          {children}
        </Document>
      )}

      {!numPages && !loading && (
        <div className="flex items-center justify-center h-64">
          <p className="text-muted-foreground">No pages to display</p>
        </div>
      )}

      {numPages && sectionsLength === 0 && !loading && (
        <div className="flex flex-col items-center justify-center h-64 p-8">
          <BookText className="w-12 h-12 text-muted-foreground mb-4" />
          <p className="text-muted-foreground text-center">
            PDF loaded successfully, but no sections were found.
            <br />
            The PDF will be displayed in full below.
          </p>
        </div>
      )}
    </div>
  );
}
